import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.outpost || initialState;

export const selectOutpost = createSelector(
  [selectDomain],
  selectOutpostState => selectOutpostState,
);
